import script from "./OrgUnitTree.vue?vue&type=script&setup=true&lang=js"
export * from "./OrgUnitTree.vue?vue&type=script&setup=true&lang=js"

import "./OrgUnitTree.vue?vue&type=style&index=0&id=6f84aa91&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f84aa91"]])

export default __exports__